import { MessageCircle, Target } from "lucide-react";
import type { InspirationCta } from "web_myplann/Inspiration/Components/InspirationCtaButton";
import type { InspirationGoalRecap } from "web_myplann/Inspiration/Types/InspirationTypes";
import { useContactAdvisor } from "web_myplann/Shared/Hooks/useContactAdvisor";

type Params = {
	isCold: boolean;
	coldCta: InspirationCta;
	goalRecap?: InspirationGoalRecap;
	createGoal?: { label: string; onClick: () => void };
	advisor: { label: string; message: string };
};

type InspirationCtas = {
	goalRecap?: InspirationGoalRecap;
	primaryCta?: InspirationCta;
	secondaryCta?: InspirationCta;
};

export const useInspirationCtas = ({
	isCold,
	coldCta,
	goalRecap,
	createGoal,
	advisor,
}: Params): InspirationCtas => {
	const { openChat } = useContactAdvisor();

	if (isCold) return { primaryCta: coldCta };

	const secondaryCta: InspirationCta = {
		label: advisor.label,
		icon: MessageCircle,
		variant: "tertiary",
		onClick: () => openChat(advisor.message),
	};

	if (!createGoal) return { secondaryCta };

	return {
		goalRecap,
		primaryCta: {
			label: createGoal.label,
			icon: Target,
			onClick: createGoal.onClick,
		},
		secondaryCta,
	};
};
